var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17233_100934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 3.33398H4.99992C4.07944 3.33398 3.33325 4.08018 3.33325 5.00065V6.66732C3.33325 7.58779 4.07944 8.33398 4.99992 8.33398H14.9999C15.9204 8.33398 16.6666 7.58779 16.6666 6.66732V5.00065C16.6666 4.08018 15.9204 3.33398 14.9999 3.33398Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 11.666H4.99992C4.07944 11.666 3.33325 12.4122 3.33325 13.3327V14.9993C3.33325 15.9198 4.07944 16.666 4.99992 16.666H14.9999C15.9204 16.666 16.6666 15.9198 16.6666 14.9993V13.3327C16.6666 12.4122 15.9204 11.666 14.9999 11.666Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17233_100934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.0dd21bd3dd969cf12fa6383481474915.svg";
export { ForwardRef as ReactComponent };